import React from 'react';
import '../../styles/searchpage.css';
import '../../styles/landingPage.css';
import '../../styles/landingPage.css';
import '../../styles/artworks.css';
import '../../styles/common_elements.css';
import Button from 'react-bulma-components/lib/components/button';
import Modal from 'react-bulma-components/lib/components/modal';
import { Redirect } from 'react-router-dom';
import CategoryCard from '../cardHolders/categoriesCard'
import Filter from '../../helpers/filter'
import { inject, observer } from 'mobx-react';

const trendingStyles = [
    { value: "living_room", name: 'LIVING ROOM', path: require('../../assets/livingroom_thumb.jpg'), colored: true },
    { value: "bedroom", name: 'BEDROOM', path: require('../../assets/bedroom_thumb.jpg'), colored: true },
    { value: "cafe", name: 'CAFE', path: require('../../assets/cafe_thumb.jpg'), colored: true },
    { value: "office", name: 'OFFICE', path: require('../../assets/office_thumb.jpg'), colored: true }
]
@inject('userStore', 'generalStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'searchPageArtworksStore', 'categoryPageArtworksStore')
@observer
export default class searchResultspage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            artworksList: [],
            uniqueContainerId: "container_" + new Date().getTime() + Math.random(),
            reachedPageEnd: false,
        }
    }



    render() {

        var catList = [
            {
                spaces: [
                    { value: "YMC Living", name: 'LIVING ROOM', path: require('../../assets/livingroom_thumb.jpg'), src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._SY500_.jpg" },
                    { value: "YMC Bedroom", name: 'BEDROOM', path: require('../../assets/bedroom_thumb.jpg'), src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._SY500_.jpg" },
                    { value: "YMC Cafes", name: 'CAFES', path: require('../../assets/cafe_thumb.jpg'), src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._SY500_.jpg" },
                    { value: "YMC Workspaces", name: 'Workspaces', path: require('../../assets/office_thumb.jpg'), src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._S" },
                    { value: "YMC kitchen", name: 'KITCHEN', path: require('../../assets/kitchen_thumb.jpg'), src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._S" },
                    { value: "YMC Kidsroom", name: 'KIDS ROOM', path: require('../../assets/outdoor_thumb.jpg'), src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._S" },
                    { value: "YMC Hotels", name: 'HOTELS', path: require('../../assets/hotel_thumb.jpg'), src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._S" },
                    { value: "YMC Restaurants", name: 'RESTAURANTS', path: require('../../assets/restaurant_thumb.jpg'), src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._S" },
                    { value: "YMC Hospitals", name: 'HOSPITALS', path: require('../../assets/hospital_thumb.jpg'), src: "https://images-na.ssl-images-amazon.com/images/I/91t1zqhVPjL._S" },

                ],
                styles: [
                    { value: "T2019 Global Aesthetics", name: 'Global Aesthetics', path: require('../../assets/artistic.jpg'), colored: true },
                    { value: "T2019 Modern Botanical", name: 'Modern Botanical', path: require('../../assets/botanicals.jpg'), colored: true },
                    { value: "T2019 Black & White", name: 'Black & White', path: require('../../assets/blacknwhite.jpg'), colored: true },
                    { value: "T2019 Maximalism", name: 'Maximalism', path: require('../../assets/maximalism.jpg'), colored: true }
                ],

                ym_collection: [
                    { value: "YMC Portraits", name: 'PORTRAITS', path: require('../../assets/portraits_thumb.jpg'), colored: true },
                    { type: "search", value: "Oil", name: 'OIL', path: require('../../assets/oil.jpg'), colored: true },
                    { value: "YMC Abstract", name: 'ABSTRACT', path: require('../../assets/abstract_thumb.jpg'), colored: true },
                    { value: "YMC Landscape", name: 'LANDSCAPE', path: require('../../assets/landscape_thumb.jpg'), colored: true },
                    { type: "search", value: "Acrylic", name: 'ACRYLIC', path: require('../../assets/acrylic.jpg'), colored: true },
                    { type: "search", value: "Watercolor", name: 'WATERCOLOR', path: require('../../assets/watercolor.jpg'), colored: true },
                    { type: "search", value: "Charcoal", name: 'CHARCOAL', path: require('../../assets/charcoal.jpg'), colored: true },
                    { type: "search", value: "Graphite", name: 'GRAPHITE', path: require('../../assets/graphite.jpg'), colored: true },
                    { type: "search", value: "Pencil", name: 'PENCIL', path: require('../../assets/pencil.jpg'), colored: true },
                    { type: "search", value: "Mixed", name: 'MIXED', path: require('../../assets/mixed.jpg'), colored: true },
                    { type: "search", value: "Pastel", name: 'PASTEL', path: require('../../assets/pastels.jpg'), colored: true },
                    { type: "search", value: "Ink", name: 'INK', path: require('../../assets/ink.jpg'), colored: true },
                    { value: "YMC Surrealism", name: 'SURREALISM', path: require('../../assets/surrealism_thumb.jpg'), colored: true },
                    { value: "YMC Contemporary", name: 'CONTEMPERORY', path: require('../../assets/contemporary_thumb.jpg'), colored: true },
                    { value: "YMC Traditional", name: 'TRADITIONAL', path: require('../../assets/traditional_thumb.jpg'), colored: true },
                    { value: "YMC Colourful", name: 'COLOURFUL ARTWORKS', path: require('../../assets/colorful_thumb.jpg'), colored: true },
                    { value: "YMC Figures", name: 'FIGURES', path: require('../../assets/figures_thumb.jpg'), colored: true },
                    { value: "YMC Patterns", name: 'PATTERNS', path: require('../../assets/patterns_thumb.jpg'), colored: true },

                ],
                // artistCategory:true,
                techniques: [
                    { artistCategory: true, value: "Oil", name: 'OIL', path: require('../../assets/oil.jpg'), colored: true },
                    { value: "Acrylic", name: 'ACRYLIC', path: require('../../assets/acrylic.jpg'), colored: true },
                    { value: "Watercolor", name: 'WATERCOLOR', path: require('../../assets/watercolor.jpg'), colored: true },
                    { value: "Charcoal", name: 'CHARCOAL', path: require('../../assets/charcoal.jpg'), colored: true },
                    { value: "Graphite", name: 'GRAPHITE', path: require('../../assets/graphite.jpg'), colored: true },
                    { value: "Pencil", name: 'PENCIL', path: require('../../assets/pencil.jpg'), colored: true },
                    { value: "Mixed", name: 'MIXED', path: require('../../assets/mixed.jpg'), colored: true },
                    { value: "Pastel", name: 'PASTEL', path: require('../../assets/pastels.jpg'), colored: true },
                    { value: "Ink", name: 'INK', path: require('../../assets/ink.jpg'), colored: true },
                ]
            }
        ]

        // console.log("this is props", this.state.artworksList)
        return (

            <div className="searchpage-container" style={{ minHeight: "" }} >
                <div className="searchpage-content-container">

                    <div className="searchpage-heading">
                        <div className="heading-btn-row filter-heading" style={{ width: "100%" }}>
                            <div className="pl-0">
                                <h3 className="heading-left-text">{this.props.match.params.title}</h3>
                                <hr className="line-category-name"></hr>
                            </div>

                        </div>

                    </div>
                    <div className="row mt-15 mb-15" id={this.state.uniqueContainerId}>
                        <CategoryCard
                            // this.props.match.params.catId
                            artistCategory={catList[0][this.props.match.params.catId][0].artistCategory} colored={true} categoriesDetails={catList[0][this.props.match.params.catId]} />
                    </div>

                </div>

            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/products/categoryList.js